import { useContext } from 'react'
import { casinoStoreKey } from '../casinoStoreConstants'
import { StoreContext } from '../../StoreProvider'

export const useCasinoStore = () => {
  const { selectors } = useContext(StoreContext)

  return selectors[casinoStoreKey]
}
